import { AssetRecommendationListItem } from "./type";
import { EdPicksForYouItem } from "../../AlphaPick/EdPicksForYou";
import { RecommendScopeFormattedAsset } from "@hooks/useRecommendScopeContentsQuery";
import { buildJsonRenderAssetDetailPath } from "./buildJsonRenderAssetDetailPath";
import { cn } from "utils";
import EdgenDrawerCallable from "../../EdgenDrawerCallable";

export interface AssetRecommendationListProps {
  sectionLabel?: string;
  assets: AssetRecommendationListItem[];
  className?: string;
  listClassName?: string;
}

/**
 * 说明：资产推荐列表，展示多个资产的价格、涨跌、推荐理由和评分。 Figma：81033:18334
 * @param param0
 * @returns
 */
export const AssetRecommendationList: React.FC<
  AssetRecommendationListProps
> = ({ sectionLabel, className, assets }) => {
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <p className="body_m text-content_secondary">{sectionLabel}</p>
      <div className="flex flex-col gap-6  p-2">
        {assets.map((p, i) => (
          <EdPicksForYouItem
            key={p.id ?? `${p.assetSymbol}-${i}`}
            id={p.id}
            logo={p.assetLogo}
            symbol={p.assetSymbol}
            price={p.assetPriceUsd}
            change1d={p.priceChange24h}
            overall_score={p.assetScoreValue}
            href={buildJsonRenderAssetDetailPath(p.type, p.assetSymbol, p.id)}
            onClick={(_e) => {
              EdgenDrawerCallable.end(false);
            }}
            multi_language_contents={
              //需要修改
              {
                "en-US": {
                  language: "en",
                  title: p.reason,
                },
                // 临时添加中文文案
                "zh-CN": {
                  language: "zh",
                  title: p.reason,
                },
              } as unknown as RecommendScopeFormattedAsset["multi_language_contents"]
            }
          />
        ))}
      </div>
    </div>
  );
};
